import { Hero } from "@/components/home/Hero";
import { MarketPulse } from "@/components/home/MarketPulse";
import { FundLeaders } from "@/components/home/FundLeaders";
import { BrokerSnapshot } from "@/components/home/BrokerSnapshot";
import { InsuranceSnapshot } from "@/components/home/InsuranceSnapshot";
import { PartnerBand } from "@/components/home/PartnerBand";
import { RealEstateBand } from "@/components/home/RealEstateBand";
import { MarketsBand } from "@/components/home/MarketsBand";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <RealEstateBand />
      <MarketPulse />
      <FundLeaders />
      <BrokerSnapshot />
      <InsuranceSnapshot />
      <MarketsBand />
      <PartnerBand />
    </div>
  );
}
